module.exports = __webpack_public_path__ + "static/media/LEASEGURU_logo.8dc5586b.svg";